<ng-dialog-header title="Shipper Profile"></ng-dialog-header>
<mat-dialog-content>
  <ns-grid #gridWrapper
           [name]="gridConfigs.gridName"
           [gridTitle]="gridConfigs.gridTitle"
           [config]="gridConfigs.headerOptions"
           [data]="data"
           [columns]="gridConfigs.columns"
           [loading]="loading"
           [gridOptions]="gridConfigs.options"
  ></ns-grid>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
    <button mat-flat-button aria-label="Back" class="ml-1" color="accent"
            [disabled]="!gridWrapper.ag?.api?.getSelectedRows()?.length"
            (click)="loadShipment.emit(gridWrapper.ag!.api!.getSelectedRows()[0])">
      Load Shipment
    </button>
  </div>
</ng-dialog-footer>
